
import Enumerable from "linq";
import { Component, Mixins } from "vue-property-decorator";
import { FilterableMasterSelectableMixin } from "../../../system/selectors/mixins";
import { DomainRegistry } from "../../../../domain";
import { DepartmentGroup } from "../../../../domain/department";

@Component({
})
export default class DepartmentGroupSelectableMixin extends Mixins(FilterableMasterSelectableMixin) {
  values: DepartmentGroup[];

  created() {
    const repository = DomainRegistry.department.getDepartmentRepository();
    repository.getDepartmentGroups()
      .then(groups => this.values = this.filterByScope(groups).filter(g => !g.isDeleted))
      .catch(e => {
        this.$error(
          this.$wording.common.departmentGroup + "情報取得失敗",
          this.$wording.common.departmentGroup + "情報を取得できませんでした。",
          e,
        );
      });
  }

  private filterByScope(groups: DepartmentGroup[]): DepartmentGroup[] {
    if (!this.$store.getters.isDepartmentGroupScopeEnable) { return groups; }
    const referenceableDepartmentGroups = this.$store.getters.referenceableDepartmentGroups as DepartmentGroup[];
    const selectableDepartmentGroupCodes = referenceableDepartmentGroups.map(g => g.id);
    const loginDepartmentGroup = this.$store.getters.departmentGroup as DepartmentGroup;
    if (loginDepartmentGroup) {
      selectableDepartmentGroupCodes.push(loginDepartmentGroup.id);
    }
    return Enumerable.from(groups)
      .where(g => selectableDepartmentGroupCodes.some(code => g.id === code))
      .toArray();
  }
}
